/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerSegmentsSearchQueryResponse, PntAppControllerSegmentsSearchPathParams, PntAppControllerSegmentsSearchQueryParams } from "../models/PntAppControllerSegmentsSearch";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntAppControllerSegmentsSearch } from "../axios/pntAppControllerSegmentsSearch";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntAppControllerSegmentsSearchQueryKey = (slug: PntAppControllerSegmentsSearchPathParams["slug"], params: PntAppControllerSegmentsSearchQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/search', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntAppControllerSegmentsSearchQueryKey = ReturnType<typeof pntAppControllerSegmentsSearchQueryKey>

export function pntAppControllerSegmentsSearchQueryOptions(slug: PntAppControllerSegmentsSearchPathParams["slug"], params: PntAppControllerSegmentsSearchQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntAppControllerSegmentsSearchQueryKey(slug, params)
        return queryOptions<PntAppControllerSegmentsSearchQueryResponse, ResponseErrorConfig<Error>, PntAppControllerSegmentsSearchQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntAppControllerSegmentsSearch(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Search segment transcriptions for given terms within a date range.
 * {@link /pnt/v2/segments/:slug/search}
 */
export function usePntAppControllerSegmentsSearch<TData = PntAppControllerSegmentsSearchQueryResponse, TQueryData = PntAppControllerSegmentsSearchQueryResponse, TQueryKey extends QueryKey = PntAppControllerSegmentsSearchQueryKey>(slug: PntAppControllerSegmentsSearchPathParams["slug"], params: PntAppControllerSegmentsSearchQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntAppControllerSegmentsSearchQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntAppControllerSegmentsSearchQueryKey(slug, params)
         

         const query = useQuery({
          ...pntAppControllerSegmentsSearchQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}